"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get convertDateFormatForConcat () {
        return convertDateFormatForConcat;
    },
    get getWeekdayByIndex () {
        return getWeekdayByIndex;
    },
    get getWeekdayByText () {
        return getWeekdayByText;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _convertDateFormat = require("./convertDateFormat");
const _Column = /*#__PURE__*/ _interop_require_default(require("~/models/Column"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function getWeekdayByText(v) {
    return ({
        monday: 0,
        tuesday: 1,
        wednesday: 2,
        thursday: 3,
        friday: 4,
        saturday: 5,
        sunday: 6
    })[(v == null ? void 0 : v.toLowerCase()) || 'monday'];
}
function getWeekdayByIndex(idx) {
    return ({
        0: 'monday',
        1: 'tuesday',
        2: 'wednesday',
        3: 'thursday',
        4: 'friday',
        5: 'saturday',
        6: 'sunday'
    })[idx || 0];
}
async function convertDateFormatForConcat(context, o, columnIdToUidt, query, clientType) {
    if ((o == null ? void 0 : o.type) === 'Identifier' && (o == null ? void 0 : o.name) in columnIdToUidt && columnIdToUidt[o.name] === _nocodbsdk.UITypes.Date) {
        const meta = (await _Column.default.get(context, {
            colId: o.name
        })).meta;
        if (clientType === 'mysql2') {
            query = `DATE_FORMAT(${query}, '${(0, _convertDateFormat.convertDateFormat)(meta.date_format, clientType)}')`;
        } else if (clientType === 'pg') {
            query = `TO_CHAR(${query}, '${(0, _convertDateFormat.convertDateFormat)(meta.date_format, clientType)}')`;
        } else if (clientType === 'sqlite3') {
            query = `strftime('${(0, _convertDateFormat.convertDateFormat)(meta.date_format, clientType)}', ${query})`;
        }
    }
    return query;
}
